module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-01@2x.13a4776.webp";